import { render, staticRenderFns } from "./manufacturer.vue?vue&type=template&id=4a81452e"
import script from "./manufacturer.vue?vue&type=script&lang=js"
export * from "./manufacturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports